import React from "react"
import { useValueRef } from "@/hooks/useValueRef";
import { useDropdown, DropdownItems } from "../UiBlocks/components/Dropdown";

interface ContextMenuProps {
  onAction: (action: 'rename' | 'archive' | 'delete') => void
}

export function useContextMenu(props: ContextMenuProps) {
  const propsRef = useValueRef(props);

  const contextItems = React.useMemo<DropdownItems>(() => {
    return [
      {id: 'rename', label: 'Rename', disabled: false},
      // {id: 'archive', label: 'Archive', disabled: false},
      '-',
      {id: 'delete', label: 'Delete', disabled: false},
    ];
  }, []);

  const dropdown = useDropdown({
    items: contextItems,
    onActivateItem: (itemId: string) => {
      propsRef.current.onAction(itemId as any);
    }
  });

  return {
    jsx: dropdown.jsx,
    open: dropdown.open,
    close: dropdown.close,
  };
}
